/**
 * Funções de validação para Lead Time
 */
import { VALIDATION_TYPES } from './types';

export function validateHeaders(headers) {
  const requiredHeaders = ['ID', 'Tipo de Item', 'Committed Date', 'Closed Date'];
  return requiredHeaders.filter(header => !headers.includes(header));
}

export function generateHeaderError(missingHeaders, headers) {
  let errorMessage = `❌ Erro na estrutura do arquivo:\n`;
  errorMessage += `\n🔍 Colunas obrigatórias faltando:\n`;
  missingHeaders.forEach(header => {
    errorMessage += `• ${header}\n`;
  });
  errorMessage += `\n📋 Colunas encontradas no arquivo:\n`;
  headers.forEach(header => {
    errorMessage += `• ${header}\n`;
  });
  return errorMessage;
}

export function generateValidationError(validationErrors) {
  let errorMessage = `❌ Encontrados ${validationErrors.length} erro(s) no arquivo:\n`;
  
  // Agrupar erros por tipo
  const errorsByType = validationErrors.reduce((acc, error) => {
    acc[error.type] = acc[error.type] || [];
    acc[error.type].push(error);
    return acc;
  }, {});

  // Resumo dos tipos de erro
  const errorTypeDescriptions = {
    'missing_id': 'campo ID vazio',
    'missing_tipo': 'campo Tipo de Item vazio',
    'missing_committed_date': 'campo Committed Date vazio',
    'missing_closed_date': 'campo Closed Date vazio',
    'invalid_committed_date': 'Committed Date inválida',
    'invalid_closed_date': 'Closed Date inválida'
  };

  Object.entries(VALIDATION_TYPES).forEach(([key, value]) => {
    if (errorsByType[value.type]) {
      const description = errorTypeDescriptions[value.type] || value.type;
      errorMessage += `• ${errorsByType[value.type].length} linha(s) com ${description}\n`;
    }
  });

  // Detalhes específicos dos erros
  errorMessage += `\n🔍 Detalhes dos erros:\n`;
  validationErrors.slice(0, 10).forEach(error => {
    errorMessage += `• ${error.message}\n`;
  });
  if (validationErrors.length > 10) {
    errorMessage += `• ... e mais ${validationErrors.length - 10} erro(s)\n`;
  }

  return errorMessage;
}

export function validateData(json) {
  const validationErrors = [];
  const validData = [];

  json.forEach((item, index) => {
    const lineNumber = index + 2; // Linha 1 são os headers
    const id = item.ID?.toString().trim();
    const tipoItem = item['Tipo de Item']?.toString().trim();
    const committedDate = item['Committed Date']?.toString().trim();
    const closedDate = item['Closed Date']?.toString().trim();

    // Validar campos obrigatórios
    if (!id) {
      validationErrors.push({
        type: VALIDATION_TYPES.MISSING_ID.type,
        line: lineNumber,
        message: VALIDATION_TYPES.MISSING_ID.getMessage(lineNumber)
      });
    }

    if (!tipoItem) {
      validationErrors.push({
        type: VALIDATION_TYPES.MISSING_TIPO.type,
        line: lineNumber,
        message: VALIDATION_TYPES.MISSING_TIPO.getMessage(lineNumber, id)
      });
    }

    if (!committedDate) {
      validationErrors.push({
        type: VALIDATION_TYPES.MISSING_COMMITTED_DATE.type,
        line: lineNumber,
        message: VALIDATION_TYPES.MISSING_COMMITTED_DATE.getMessage(lineNumber, id)
      });
    } else {
      // Validar formato da data
      const date = new Date(committedDate);
      if (isNaN(date.getTime())) {
        validationErrors.push({
          type: VALIDATION_TYPES.INVALID_COMMITTED_DATE.type,
          line: lineNumber,
          message: VALIDATION_TYPES.INVALID_COMMITTED_DATE.getMessage(lineNumber, committedDate, id)
        });
      }
    }

    if (!closedDate) {
      validationErrors.push({
        type: VALIDATION_TYPES.MISSING_CLOSED_DATE.type,
        line: lineNumber,
        message: VALIDATION_TYPES.MISSING_CLOSED_DATE.getMessage(lineNumber, id)
      });
    } else {
      // Validar formato da data
      const date = new Date(closedDate);
      if (isNaN(date.getTime())) {
        validationErrors.push({
          type: VALIDATION_TYPES.INVALID_CLOSED_DATE.type,
          line: lineNumber,
          message: VALIDATION_TYPES.INVALID_CLOSED_DATE.getMessage(lineNumber, closedDate, id)
        });
      }
    }

    // Se todos os campos obrigatórios estão presentes e válidos, adicionar aos dados válidos
    if (id && tipoItem && committedDate && closedDate) {
      const committedDateObj = new Date(committedDate);
      const closedDateObj = new Date(closedDate);
      if (!isNaN(committedDateObj.getTime()) && !isNaN(closedDateObj.getTime())) {
        validData.push(item);
      }
    }
  });

  return { validationErrors, validData };
}
